const OVERFLOW_CLASS_1 = 'is-toolbar-overflow-1';
const OVERFLOW_CLASS_2 = 'is-toolbar-overflow-2';

export const useToolbarOverflow = () => {
  let contentArea = null;
  let toolbar = null;
  let actionsArea = null;
  let toolbarObserver = null;
  let resizeHandler = null;
  let fontsReadyToken = 0;

  // 見えている子(display:none や幅0でない)の上端を整数に丸めた値の種類数を返す。
  // 種類が2以上なら、ボタンが折り返して複数段になっている
  const countRows = () => {
    const tops = new Set();
    Array.from(actionsArea.children).forEach((child) => {
      if (child.offsetParent === null) {
        return;
      }
      const rect = child.getBoundingClientRect();
      if (!(rect.width > 0)) {
        return;
      }
      tops.add(Math.round(rect.top));
    });
    return tops.size;
  };

  // ボタンが1段に入らないとき、1段目(タグ等を「その他」へ)、それでも入らなければ2段目(ゴミ箱等も)の class を付ける。
  // class を外す→読む→付ける→読み直す、を1回の同期処理で行い、途中の状態は描画されない
  const checkToolbarOverflow = () => {
    if (!toolbar || !actionsArea) {
      return;
    }

    toolbar.classList.remove(OVERFLOW_CLASS_1, OVERFLOW_CLASS_2);

    if (countRows() < 2) {
      return;
    }
    toolbar.classList.add(OVERFLOW_CLASS_1);

    if (countRows() < 2) {
      return;
    }
    toolbar.classList.add(OVERFLOW_CLASS_2);
  };

  const initToolbarOverflow = () => {
    teardownToolbarOverflow();

    contentArea = document.querySelector('.content-area');
    if (!contentArea) {
      return;
    }

    // 直下に .toolbar-actions-area を持つ .toolbar だけが対象
    const candidates = Array.from(contentArea.querySelectorAll('.toolbar'));
    toolbar = candidates.find((el) => el.querySelector(':scope > .toolbar-actions-area')) || null;
    if (!toolbar) {
      contentArea = null;
      return;
    }
    actionsArea = toolbar.querySelector(':scope > .toolbar-actions-area');

    // 中央ペインの幅だけを見る。ツールバーの class を変えても中央の幅は変わらないので繰り返しにならない
    if (typeof window.ResizeObserver === 'function') {
      toolbarObserver = new window.ResizeObserver(() => {
        checkToolbarOverflow();
      });
      toolbarObserver.observe(contentArea);
    } else {
      resizeHandler = () => {
        checkToolbarOverflow();
      };
      window.addEventListener('resize', resizeHandler);
    }

    checkToolbarOverflow();

    // アイコンのフォントの読み込みでボタンの幅が変わるため、読み込み後にも決め直す
    if (document.fonts?.ready) {
      const token = ++fontsReadyToken;
      document.fonts.ready.then(() => {
        if (token === fontsReadyToken) {
          checkToolbarOverflow();
        }
      });
    }
  };

  const teardownToolbarOverflow = () => {
    fontsReadyToken += 1;

    if (toolbarObserver) {
      toolbarObserver.disconnect();
      toolbarObserver = null;
    }

    if (resizeHandler) {
      window.removeEventListener('resize', resizeHandler);
      resizeHandler = null;
    }

    if (toolbar) {
      toolbar.classList.remove(OVERFLOW_CLASS_1, OVERFLOW_CLASS_2);
    }

    contentArea = null;
    toolbar = null;
    actionsArea = null;
  };

  return {
    initToolbarOverflow,
    teardownToolbarOverflow,
    // 選択数の札・表示の切り替えなど、中央の幅が変わらずにボタンの幅が変わるときに呼ぶ公開関数
    checkToolbarOverflow,
  };
};
